// Public UI adapted from Klargo-Reference/components/landing/heroDeal.ts.
export const HERO_DEAL = {
    reg: 'MHT428',
    model: 'Volvo V40 T3 Momentum',
    price: '75 000 kr',
    seller: 'Johan Lindqvist',
    buyer: 'Sara Ek',
    contractNumber: 'KLG-2026-000148',
    dateIso: '2026-04-14',
    broker: 'Zmarta',
};
export const INSURANCE_PROVIDERS = ['hero.insurer.a', 'hero.insurer.b', 'hero.insurer.c'];
export const HERO_CARD_ORDER = ['contract', 'payment', 'transfer', 'insurance'];
